import { Suspense } from 'react'

import { useSubscriptionSuccessToast } from './hooks/use-subscription-success-toast'
import { SettingsContent } from './ui/settings-content/settings-content'
import { SettingsHeader } from './ui/settings-header'
import { SettingsLoading } from './ui/settings-loading'

export const SettingsPage = () => {
  useSubscriptionSuccessToast()

  return (
    <div className="px-10 py-11">
      <SettingsHeader />

      <div className="mt-8 max-w-[670px]">
        <Suspense fallback={<SettingsLoading />}>
          <SettingsContent />
        </Suspense>
      </div>
    </div>
  )
}
